module.exports = __webpack_public_path__ + "img/1.0343f910.png";